<template>
  <layout>
    <b-row>
      <b-col>
        <h1>Translations</h1>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="3">
        <b-form-input
          v-model="filter"
          placeholder="Search by key" />
      </b-col>

      <b-col md="9">
        <b-form-checkbox-group
          v-model="selected"
          :options="options"
          size="sm"
          variant="outline-info">
          <b-button
            size="sm"
            @click="reload">
            Reload
          </b-button>
        </b-form-checkbox-group>


      </b-col>

    </b-row>

    <br>
    <b-table
      :items="dictionary"
      :fields="fields"
      :tbody-tr-class="['cursor-pointer']"
      hover
      striped
      @row-clicked="onTableRowClick">
      <template
        slot="actions"
        slot-scope="row">
        <b-button
          v-for="action in row.item.actions"
          :key="action"
          @click.self="row.toggleDetails">
          {{ action }}
        </b-button>
      </template>

      <template
        slot="row-details"
        slot-scope="{ item }">
        <translation-edit
          :item="item"
          :locales="locales"
          @submit="onSubmit" />
      </template>
    </b-table>
  </layout>
</template>

<script>
  import Layout from '../layouts/Default';
  import BTable from "bootstrap-vue/src/components/table/table";
  import BFormInput from "bootstrap-vue/src/components/form-input/form-input";
  import BRow from "bootstrap-vue/src/components/layout/row";
  import BCol from "bootstrap-vue/src/components/layout/col";
  import BFormCheckboxGroup from "bootstrap-vue/src/components/form-checkbox/form-checkbox-group";
  import BButton from "bootstrap-vue/src/components/button/button";
  import BFormGroup from "bootstrap-vue/src/components/form-group/form-group";
  import BBadge from "bootstrap-vue/src/components/badge/badge";
  import TranslationEdit from "./TranslationEdit";

  export default {
    name: 'Index',

    components: {
      TranslationEdit,
      BButton,
      BFormCheckboxGroup,
      BCol,
      BRow,
      BFormInput,
      BTable,
      Layout,
    },

    data() {
      return {
        dictionaries: [],
        locales: [],
        selected: [],
        filter: '',
        fields: [],
      }
    },

    computed: {
      dictionary() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        const selected = this.selected.sort((first, second) => first.localeCompare(second));
        return this.dictionaries
          .filter(word => {
            const filterLowercase = this.filter.trim().toLowerCase();
            for (const key in word.values) {
              const value = word.values[key];
              if (value && value.toLowerCase().indexOf(filterLowercase) > -1) {
                return true;
              }
            }
            return word.key.toLowerCase().indexOf(filterLowercase) > -1 ||
              word.group.toLowerCase().indexOf(filterLowercase) > -1;
          })
          .map(word => {
            const newValue = {};
            for (const locale of selected) {
              newValue[locale] = word.values[locale];
            }
            return {...word, values: newValue};
          })
          .map(word => ({key: word.key, group: word.group, ...word.values, actions: ['edit']}))
      },

      options() {
        return this.locales.map(locale => ({text: locale.name, value: locale.locale}))
      }
    },

    watch: {
      selected(newLocales, oldLocales) {

        if (newLocales !== oldLocales) {
          const newFields = [{
            key: 'group',
            label: 'Group'
          }, {
            key: 'key',
            label: 'Key'
          }];

          const locales = newLocales.sort();
          for (const locale of locales) {
            const lang = this.locales.find(loc => loc.locale === locale);
            newFields.push({
              key: lang.locale,
              label: lang.name
            })
          }

          newFields.push({
            key: 'actions',
            label: 'Actions',
          });
          this.fields = newFields;
        }
      }
    },

    created() {
      this.fetchLanguages()
        .then(response => {
          this.locales = response.data;
          this.selected = this.locales.map(locale => locale.locale);
          return this.fetchDictionary(this.selected);
        })
        .then(response => {
          this.dictionaries = response.data;
        })
        .catch(err => console.error(err));
    },

    methods: {
      fetchLanguages() {
        return this.$http.get('/translations/locales');
      },

      fetchDictionary(langs) {
        return this.$http.get('/translations/strings', {params: {locales: langs.join(',')}});
      },

      onTableRowClick(item) {
        this.$set(item, '_showDetails', !item._showDetails);
      },

      onSubmit(item) {
        const entry = this.dictionaries.find(word => item.key === word.key);

        if (entry) {
          const values = {};
          for (const locale of this.locales) {
            if (item[locale.locale])
              values[locale.locale] = item[locale.locale];
          }

          this.$http.put(`translations/strings/${entry.id}`, {values})
            .then(({data}) => {
              this.dictionaries = this.dictionaries.map(word => word.id === data.id ? data : word);
            })
            .catch(err => this.$toast.success(this.$tr(err.response.message)));

        }
      },

      async reload() {
        try {
          const response = await this.withUiBlocker(this.fetchDictionary(this.locales.map(locale => locale.locale)));
          this.dictionaries = response.data;
        } catch (err) {
          console.error(err)
        }
      }
    },
  }
</script>
